import StaffRoleExample from './StaffRoleExample';
import authRoles from '../../../auth/authRoles';

const StaffRoleExampleConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.provider, // ['admin','provider']
  routes: [
    {
      path: 'auth/staff-role-example',
      element: <StaffRoleExample />,
    },
  ],
};

export default StaffRoleExampleConfig;
